export default {
      id: "ic_party_popper-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_party_popper-usage",
      toString: function () {
        return this.url;
      }
    }